import EDC from '../../shared/globals';

/**
 *
 */
EDC.Games.CountingDots.DotBox = function (scene) {
  this.scene = scene;
  this.container = null;
  this.dotsContainer = null;
  this.dots = [];
  this.dotsCounter = 0;
  this.dotsAreaWidth = 0;
  this.dotsAreaHeight = 0;
  this.dotScale = 0.75;
  this.dotGameColorIndex = -1;
  this.dotIterationColorIndex = -1;
  this.maxColumns = 5;
};
/**
 *
 */
EDC.Games.CountingDots.DotBox.prototype.create = function (x, y) {
  this.container = this.scene.add.container(x, y);
  this.dotsContainer = this.scene.add.container(0, 0);
  const box = this.scene.add.sprite(0, 0, 'dot-box');
  this.dotsAreaWidth = (box.width * 80) / 100;
  this.dotsAreaHeight = (box.height * 65) / 100;
  this.container.add(box);
  this.container.add(this.dotsContainer);

  this.dotsContainer.x -= this.dotsAreaWidth / 2;
  this.dotsContainer.y -= this.dotsAreaHeight / 2;

  return this;
};
/**
 *
 */
EDC.Games.CountingDots.DotBox.prototype.disappearDots = function () {
  for (let i = 0; i < this.dots.length; i++) {
    const dot = this.dots[i];
    this.scene.tweens.add({
      targets: dot,
      alpha: 0,
      duration: 500,
      ease: 'Linear',
      delay: 60 * i,
      onComplete: () => {
        this.dotsCounter = this.dotsCounter + 1;
        if (this.dotsCounter >= this.dots.length) {
          this.destroyDots();
        }
      },
    });
  }
};
/**
 *
 */
EDC.Games.CountingDots.DotBox.prototype.appearDots = function () {
  for (let i = 0; i < this.dots.length; i++) {
    const dot = this.dots[i];
    this.scene.tweens.add({
      targets: dot,
      alpha: 1,
      duration: 300,
      ease: 'Linear',
      delay: 60 * i,
      onComplete: () => {},
    });
  }
};
/**
 *
 */
EDC.Games.CountingDots.DotBox.prototype.destroyDots = function () {
  for (let i = 0; i < this.dots.length; i++) {
    this.container.remove(this.dots[i]);
    this.dots[i].destroy();
  }
  this.dots = [];
  this.dotsCounter = 0;
  this.dotIterationColorIndex = -1;
  this.scene.events.emit(this.scene.signals.S_DOTS_DISAPPEARED);
};
/**
 *
 */
EDC.Games.CountingDots.DotBox.prototype.generateDots = function (count) {
  let rows = Math.floor(count / this.maxColumns);
  if (count % this.maxColumns > 0) rows += 1;
  let x = 0;
  let y = 0;
  let currentColumn = 0;
  let currentRow = 0;
  const slotHeight = this.dotsAreaHeight / rows;
  const slotWidth = rows > 1 ? this.dotsAreaWidth / this.maxColumns : this.dotsAreaWidth / count;

  for (let i = 0; i < count; i++) {
    x = currentColumn * slotWidth + slotWidth / 2;
    y = currentRow * slotHeight + slotHeight / 2;
    const dot = this.scene.add.sprite(x, y, this.getDotSpriteName());
    dot.setScale(this.dotScale);
    dot.setAlpha(0);
    this.dotsContainer.add(dot);
    this.dots.push(dot);
    currentColumn += 1;
    if (currentColumn >= this.maxColumns) {
      currentColumn = 0;
      currentRow += 1;
    }
  }

  this.appearDots();
};
/**
 *
 */
EDC.Games.CountingDots.DotBox.prototype.getDotSpriteName = function () {
  const dotsCount = 6;
  const rndIndex = Math.floor(Math.random() * dotsCount);
  const cfg = this.scene.gameConfig;
  if (cfg.isSameDotsColorWithinGame) {
    if (this.dotColorIndex === -1) this.dotColorIndex = rndIndex;
    return `dot${this.dotColorIndex}`;
  } else if (cfg.isSameDotsColorWithinIteration) {
    if (this.dotIterationColorIndex === -1) this.dotIterationColorIndex = rndIndex;
    return `dot${this.dotIterationColorIndex}`;
  }
  return `dot${rndIndex}`;
};

export default EDC.Games.CountingDots.DotBox;
